const getRefreshedValue = (fetchedValue, currentValue) =>
  fetchedValue !== undefined ? fetchedValue : currentValue;

export const mergeRefreshedUserStatus = ({
  currentUser,
  fetchedUserData,
  refreshedWarehouses,
}) => ({
  ...currentUser,
  status: getRefreshedValue(fetchedUserData.status, currentUser.status),
  role: getRefreshedValue(fetchedUserData.role_name, currentUser.role),
  role_id: getRefreshedValue(fetchedUserData.role_id, currentUser.role_id),
  role_ids: getRefreshedValue(fetchedUserData.role_ids, currentUser.role_ids),
  roles: getRefreshedValue(fetchedUserData.roles, currentUser.roles),
  assigned_warehouses: refreshedWarehouses,
  access_scope: getRefreshedValue(
    fetchedUserData.access_scope,
    currentUser.access_scope,
  ),
  access_summary: getRefreshedValue(
    fetchedUserData.access_summary,
    currentUser.access_summary,
  ),
  name: getRefreshedValue(fetchedUserData.name, currentUser.name),
  email: getRefreshedValue(fetchedUserData.email, currentUser.email),
  phone: getRefreshedValue(fetchedUserData.phone, currentUser.phone),
  address: getRefreshedValue(fetchedUserData.address, currentUser.address),
  shipping_address: getRefreshedValue(
    fetchedUserData.shipping_address,
    currentUser.shipping_address,
  ),
  timezone: getRefreshedValue(fetchedUserData.timezone, currentUser.timezone),
  profile_image: getRefreshedValue(
    fetchedUserData.profile_image,
    currentUser.profile_image,
  ),
  company: fetchedUserData.company || currentUser.company,
  is_superadmin: getRefreshedValue(
    fetchedUserData.is_superadmin,
    currentUser.is_superadmin,
  ),
  subscription_access: getRefreshedValue(
    fetchedUserData.subscription_access,
    currentUser.subscription_access,
  ),
  subscription_portal_only: getRefreshedValue(
    fetchedUserData.subscription_portal_only,
    currentUser.subscription_portal_only,
  ),
});

const PROFILE_FIELDS = [
  "name",
  "email",
  "phone",
  "address",
  "shipping_address",
  "timezone",
];

export const mergeSavedUserProfile = (currentUser, profileData = {}) => {
  if (!currentUser) return currentUser;

  const profileUpdates = PROFILE_FIELDS.reduce((updates, field) => {
    if (profileData[field] !== undefined) {
      updates[field] = profileData[field];
    }
    return updates;
  }, {});

  return { ...currentUser, ...profileUpdates };
};
